// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Mobile-First CSS for Email App
 * Responsive breakpoints: mobile (<768px), tablet (768-1024px), desktop (>1024px)
 */

/* =====================================================
   MOBILE BASE STYLES (<768px) + PWA Standalone Mode
   ===================================================== */

.email-app-mobile {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* Force mobile view when running as PWA (standalone mode) */
@media (display-mode: standalone) {
  .email-sidebar-desktop {
    display: none !important;
  }

  .email-list-pane {
    width: 100% !important;
    border-right: none !important;
  }

  .bottom-nav {
    display: flex !important;
  }

  .fab {
    display: flex !important;
  }

  .mobile-header {
    display: flex !important;
  }

  /* Add padding for bottom nav in PWA mode */
  .email-app-content {
    padding-bottom: 64px;
  }
}

/* Mobile: Single pane navigation */
.email-layout-mobile {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}

/* Hide desktop sidebar on mobile */
@media (max-width: 767px) {
  .email-sidebar-desktop {
    display: none !important;
  }

  .email-list-pane {
    width: 100% !important;
    border-right: none !important;
  }

  .email-detail-pane {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 100;
    background: var(--bg-primary);
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }

  .email-detail-pane.visible {
    transform: translateX(0);
  }

  /* Folders view on mobile */
  .email-folders-mobile {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh - 64px); /* Account for bottom nav */
    background: var(--bg-primary);
    z-index: 90;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    overflow-y: auto;
  }

  .email-folders-mobile.visible {
    transform: translateX(0);
  }
}

/* =====================================================
   BOTTOM NAVIGATION (Mobile Only)
   ===================================================== */

.bottom-nav {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: var(--bg-elevated);
  border-top: 1px solid var(--border-color);
  z-index: 1000;
  padding: 0 8px;
}

@media (max-width: 767px) {
  .bottom-nav {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  /* Add padding to content for bottom nav */
  .email-app-content {
    padding-bottom: 64px;
  }
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px;
  border-radius: 12px;
  transition: all 0.2s;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  min-width: 64px;
  min-height: 48px;
}

.bottom-nav-item:active {
  transform: scale(0.95);
}

.bottom-nav-item.active {
  background: var(--cyan-bright);
}

.bottom-nav-item.active .bottom-nav-icon {
  color: white;
}

.bottom-nav-item.active .bottom-nav-label {
  color: white;
}

.bottom-nav-icon {
  width: 24px;
  height: 24px;
  color: var(--text-secondary);
  transition: color 0.2s;
}

.bottom-nav-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-tertiary);
  transition: color 0.2s;
}

.bottom-nav-badge {
  position: absolute;
  top: 4px;
  right: 8px;
  background: var(--red-500);
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* =====================================================
   FLOATING ACTION BUTTON (FAB)
   ===================================================== */

.fab {
  display: none;
  position: fixed;
  bottom: 80px; /* Above bottom nav */
  right: 16px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--cyan-bright);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 999;
  -webkit-tap-highlight-color: transparent;
}

@media (max-width: 767px) {
  .fab {
    display: flex;
  }
}

.fab:active {
  transform: scale(0.9);
}

.fab:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
}

.fab-icon {
  width: 24px;
  height: 24px;
}

/* =====================================================
   MOBILE HEADER
   ===================================================== */

.mobile-header {
  display: none;
  height: 56px;
  padding: 0 16px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-elevated);
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 767px) {
  .mobile-header {
    display: flex;
  }
}

.mobile-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-header-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.mobile-back-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.mobile-back-button:active {
  background: var(--bg-elevated);
  transform: scale(0.95);
}

.mobile-menu-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.mobile-menu-button:active {
  background: var(--bg-elevated);
  transform: scale(0.95);
}

/* =====================================================
   TOUCH TARGETS (44px minimum)
   ===================================================== */

@media (max-width: 767px) {
  /* Ensure all interactive elements are at least 44px */
  button,
  .clickable,
  .touch-target {
    min-height: 44px;
    min-width: 44px;
  }

  /* Email list items */
  .email-list-item {
    padding: 16px !important;
    min-height: 88px;
  }

  /* Folder items */
  .folder-item {
    padding: 16px !important;
    min-height: 56px;
  }

  /* Star button */
  .star-button {
    padding: 12px;
  }
}

/* =====================================================
   SINGLE-PANE NAVIGATION
   ===================================================== */

@media (max-width: 767px) {
  .view-folders .email-list-pane,
  .view-folders .email-detail-pane {
    display: none;
  }

  .view-folders .email-folders-mobile {
    display: block;
  }

  .view-list .email-folders-mobile,
  .view-list .email-detail-pane {
    display: none;
  }

  .view-list .email-list-pane {
    display: block;
  }

  .view-detail .email-folders-mobile,
  .view-detail .email-list-pane {
    display: none;
  }

  .view-detail .email-detail-pane {
    display: block;
  }
}

/* =====================================================
   PULL-TO-REFRESH
   ===================================================== */

.pull-to-refresh {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-100%);
  transition: transform 0.3s;
  background: var(--bg-elevated);
  z-index: 10;
}

.pull-to-refresh.visible {
  transform: translateY(0);
}

.pull-to-refresh-spinner {
  width: 24px;
  height: 24px;
  color: var(--cyan-bright);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* =====================================================
   LOADING SKELETONS
   ===================================================== */

.skeleton {
  background: linear-gradient(
    90deg,
    var(--bg-elevated) 0%,
    rgba(255, 255, 255, 0.05) 50%,
    var(--bg-elevated) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-email-item {
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
}

.skeleton-line {
  height: 12px;
  margin-bottom: 8px;
}

.skeleton-line.short {
  width: 40%;
}

.skeleton-line.medium {
  width: 70%;
}

.skeleton-line.long {
  width: 90%;
}

/* =====================================================
   TABLET STYLES (768px - 1024px)
   ===================================================== */

@media (min-width: 768px) and (max-width: 1024px) {
  /* Two-pane layout on tablet */
  .email-sidebar-desktop {
    width: 80px !important;
  }

  .email-sidebar-desktop .folder-name {
    display: none;
  }

  .email-list-pane {
    width: 320px !important;
  }

  /* Hide bottom nav on tablet+ */
  .bottom-nav {
    display: none;
  }

  .fab {
    display: none;
  }
}

/* =====================================================
   DESKTOP STYLES (>1024px)
   ===================================================== */

@media (min-width: 1025px) {
  /* Three-pane layout */
  .email-sidebar-desktop {
    width: 256px;
  }

  .email-list-pane {
    width: 384px;
  }

  .email-detail-pane {
    flex: 1;
  }

  /* Hide mobile elements on desktop */
  .bottom-nav {
    display: none;
  }

  .fab {
    display: none;
  }

  .mobile-header {
    display: none;
  }
}

/* =====================================================
   SWIPE GESTURE VISUAL FEEDBACK
   ===================================================== */

.email-item-swipeable {
  position: relative;
  overflow: hidden;
}

.swipe-action-left,
.swipe-action-right {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.swipe-action-left {
  left: 0;
  background: var(--green-500);
}

.swipe-action-right {
  right: 0;
  background: var(--red-500);
}

.email-item-content {
  position: relative;
  background: var(--bg-primary);
  transition: transform 0.2s;
}

/* =====================================================
   SAFE AREAS (for iOS notch)
   ===================================================== */

@supports (padding: max(0px)) {
  .mobile-header {
    padding-left: max(16px, env(safe-area-inset-left));
    padding-right: max(16px, env(safe-area-inset-right));
    padding-top: max(0px, env(safe-area-inset-top));
  }

  .bottom-nav {
    padding-left: max(8px, env(safe-area-inset-left));
    padding-right: max(8px, env(safe-area-inset-right));
    padding-bottom: max(0px, env(safe-area-inset-bottom));
  }

  .fab {
    right: max(16px, env(safe-area-inset-right));
    bottom: calc(80px + max(0px, env(safe-area-inset-bottom)));
  }
}

/* =====================================================
   SMOOTH SCROLLING
   ===================================================== */

@media (max-width: 767px) {
  .email-list,
  .email-folders-mobile,
  .email-detail {
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
}

/* =====================================================
   HAPTIC FEEDBACK ANIMATION
   ===================================================== */

@media (max-width: 767px) {
  .haptic-feedback {
    animation: haptic-pulse 0.2s ease;
  }

  @keyframes haptic-pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.98);
    }
    100% {
      transform: scale(1);
    }
  }
}

/* =====================================================
   ACCESSIBILITY
   ===================================================== */

/* Focus styles for keyboard navigation */
@media (max-width: 767px) {
  button:focus-visible,
  .clickable:focus-visible {
    outline: 2px solid var(--cyan-bright);
    outline-offset: 2px;
  }
}

/* Reduce motion for accessibility */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/email/EmailApp.mobile.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;0DAE0D;;AAE1D;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,2CAA2C;EAC3C;IACE,oBAAoB;EACtB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,2BAA2B;EAC3B;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,0BAA0B,EAAE,2BAA2B;IACvD,6BAA6B;IAC7B,WAAW;IACX,4BAA4B;IAC5B,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,yCAAyC;EACzC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA,0CAA0C;EAC1C;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;0DAE0D;;AAE1D;EACE,aAAa;EACb,eAAe;EACf,YAAY,EAAE,qBAAqB;EACnC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;0DAE0D;;AAE1D;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;0DAE0D;;AAE1D;EACE,sDAAsD;EACtD;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,aAAa;EACf;AACF;;AAEA;;0DAE0D;;AAE1D;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;0DAE0D;;AAE1D;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;0DAE0D;;AAE1D;EACE,8BAA8B;EAC9B;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,sBAAsB;EACtB;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;0DAE0D;;AAE1D;EACE;IACE,kDAAkD;IAClD,oDAAoD;IACpD,+CAA+C;EACjD;;EAEA;IACE,iDAAiD;IACjD,mDAAmD;IACnD,qDAAqD;EACvD;;EAEA;IACE,4CAA4C;IAC5C,0DAA0D;EAC5D;AACF;;AAEA;;0DAE0D;;AAE1D;EACE;;;IAGE,iCAAiC;IACjC,uBAAuB;EACzB;AACF;;AAEA;;0DAE0D;;AAE1D;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,sBAAsB;IACxB;IACA;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;;0DAE0D;;AAE1D,yCAAyC;AACzC;EACE;;IAEE,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;AACpC;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/**\n * Mobile-First CSS for Email App\n * Responsive breakpoints: mobile (<768px), tablet (768-1024px), desktop (>1024px)\n */\n\n/* =====================================================\n   MOBILE BASE STYLES (<768px) + PWA Standalone Mode\n   ===================================================== */\n\n.email-app-mobile {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* Force mobile view when running as PWA (standalone mode) */\n@media (display-mode: standalone) {\n  .email-sidebar-desktop {\n    display: none !important;\n  }\n\n  .email-list-pane {\n    width: 100% !important;\n    border-right: none !important;\n  }\n\n  .bottom-nav {\n    display: flex !important;\n  }\n\n  .fab {\n    display: flex !important;\n  }\n\n  .mobile-header {\n    display: flex !important;\n  }\n\n  /* Add padding for bottom nav in PWA mode */\n  .email-app-content {\n    padding-bottom: 64px;\n  }\n}\n\n/* Mobile: Single pane navigation */\n.email-layout-mobile {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  position: relative;\n}\n\n/* Hide desktop sidebar on mobile */\n@media (max-width: 767px) {\n  .email-sidebar-desktop {\n    display: none !important;\n  }\n\n  .email-list-pane {\n    width: 100% !important;\n    border-right: none !important;\n  }\n\n  .email-detail-pane {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    z-index: 100;\n    background: var(--bg-primary);\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .email-detail-pane.visible {\n    transform: translateX(0);\n  }\n\n  /* Folders view on mobile */\n  .email-folders-mobile {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: calc(100vh - 64px); /* Account for bottom nav */\n    background: var(--bg-primary);\n    z-index: 90;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n    overflow-y: auto;\n  }\n\n  .email-folders-mobile.visible {\n    transform: translateX(0);\n  }\n}\n\n/* =====================================================\n   BOTTOM NAVIGATION (Mobile Only)\n   ===================================================== */\n\n.bottom-nav {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: var(--bg-elevated);\n  border-top: 1px solid var(--border-color);\n  z-index: 1000;\n  padding: 0 8px;\n}\n\n@media (max-width: 767px) {\n  .bottom-nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n  }\n\n  /* Add padding to content for bottom nav */\n  .email-app-content {\n    padding-bottom: 64px;\n  }\n}\n\n.bottom-nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border-radius: 12px;\n  transition: all 0.2s;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  min-width: 64px;\n  min-height: 48px;\n}\n\n.bottom-nav-item:active {\n  transform: scale(0.95);\n}\n\n.bottom-nav-item.active {\n  background: var(--cyan-bright);\n}\n\n.bottom-nav-item.active .bottom-nav-icon {\n  color: white;\n}\n\n.bottom-nav-item.active .bottom-nav-label {\n  color: white;\n}\n\n.bottom-nav-icon {\n  width: 24px;\n  height: 24px;\n  color: var(--text-secondary);\n  transition: color 0.2s;\n}\n\n.bottom-nav-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n  transition: color 0.2s;\n}\n\n.bottom-nav-badge {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n  background: var(--red-500);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* =====================================================\n   FLOATING ACTION BUTTON (FAB)\n   ===================================================== */\n\n.fab {\n  display: none;\n  position: fixed;\n  bottom: 80px; /* Above bottom nav */\n  right: 16px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--cyan-bright);\n  color: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  z-index: 999;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@media (max-width: 767px) {\n  .fab {\n    display: flex;\n  }\n}\n\n.fab:active {\n  transform: scale(0.9);\n}\n\n.fab:hover {\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n  transform: translateY(-2px);\n}\n\n.fab-icon {\n  width: 24px;\n  height: 24px;\n}\n\n/* =====================================================\n   MOBILE HEADER\n   ===================================================== */\n\n.mobile-header {\n  display: none;\n  height: 56px;\n  padding: 0 16px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-elevated);\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (max-width: 767px) {\n  .mobile-header {\n    display: flex;\n  }\n}\n\n.mobile-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mobile-header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.mobile-back-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-back-button:active {\n  background: var(--bg-elevated);\n  transform: scale(0.95);\n}\n\n.mobile-menu-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mobile-menu-button:active {\n  background: var(--bg-elevated);\n  transform: scale(0.95);\n}\n\n/* =====================================================\n   TOUCH TARGETS (44px minimum)\n   ===================================================== */\n\n@media (max-width: 767px) {\n  /* Ensure all interactive elements are at least 44px */\n  button,\n  .clickable,\n  .touch-target {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  /* Email list items */\n  .email-list-item {\n    padding: 16px !important;\n    min-height: 88px;\n  }\n\n  /* Folder items */\n  .folder-item {\n    padding: 16px !important;\n    min-height: 56px;\n  }\n\n  /* Star button */\n  .star-button {\n    padding: 12px;\n  }\n}\n\n/* =====================================================\n   SINGLE-PANE NAVIGATION\n   ===================================================== */\n\n@media (max-width: 767px) {\n  .view-folders .email-list-pane,\n  .view-folders .email-detail-pane {\n    display: none;\n  }\n\n  .view-folders .email-folders-mobile {\n    display: block;\n  }\n\n  .view-list .email-folders-mobile,\n  .view-list .email-detail-pane {\n    display: none;\n  }\n\n  .view-list .email-list-pane {\n    display: block;\n  }\n\n  .view-detail .email-folders-mobile,\n  .view-detail .email-list-pane {\n    display: none;\n  }\n\n  .view-detail .email-detail-pane {\n    display: block;\n  }\n}\n\n/* =====================================================\n   PULL-TO-REFRESH\n   ===================================================== */\n\n.pull-to-refresh {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-100%);\n  transition: transform 0.3s;\n  background: var(--bg-elevated);\n  z-index: 10;\n}\n\n.pull-to-refresh.visible {\n  transform: translateY(0);\n}\n\n.pull-to-refresh-spinner {\n  width: 24px;\n  height: 24px;\n  color: var(--cyan-bright);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* =====================================================\n   LOADING SKELETONS\n   ===================================================== */\n\n.skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--bg-elevated) 0%,\n    rgba(255, 255, 255, 0.05) 50%,\n    var(--bg-elevated) 100%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s ease-in-out infinite;\n  border-radius: 4px;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-email-item {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.skeleton-line {\n  height: 12px;\n  margin-bottom: 8px;\n}\n\n.skeleton-line.short {\n  width: 40%;\n}\n\n.skeleton-line.medium {\n  width: 70%;\n}\n\n.skeleton-line.long {\n  width: 90%;\n}\n\n/* =====================================================\n   TABLET STYLES (768px - 1024px)\n   ===================================================== */\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  /* Two-pane layout on tablet */\n  .email-sidebar-desktop {\n    width: 80px !important;\n  }\n\n  .email-sidebar-desktop .folder-name {\n    display: none;\n  }\n\n  .email-list-pane {\n    width: 320px !important;\n  }\n\n  /* Hide bottom nav on tablet+ */\n  .bottom-nav {\n    display: none;\n  }\n\n  .fab {\n    display: none;\n  }\n}\n\n/* =====================================================\n   DESKTOP STYLES (>1024px)\n   ===================================================== */\n\n@media (min-width: 1025px) {\n  /* Three-pane layout */\n  .email-sidebar-desktop {\n    width: 256px;\n  }\n\n  .email-list-pane {\n    width: 384px;\n  }\n\n  .email-detail-pane {\n    flex: 1;\n  }\n\n  /* Hide mobile elements on desktop */\n  .bottom-nav {\n    display: none;\n  }\n\n  .fab {\n    display: none;\n  }\n\n  .mobile-header {\n    display: none;\n  }\n}\n\n/* =====================================================\n   SWIPE GESTURE VISUAL FEEDBACK\n   ===================================================== */\n\n.email-item-swipeable {\n  position: relative;\n  overflow: hidden;\n}\n\n.swipe-action-left,\n.swipe-action-right {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.swipe-action-left {\n  left: 0;\n  background: var(--green-500);\n}\n\n.swipe-action-right {\n  right: 0;\n  background: var(--red-500);\n}\n\n.email-item-content {\n  position: relative;\n  background: var(--bg-primary);\n  transition: transform 0.2s;\n}\n\n/* =====================================================\n   SAFE AREAS (for iOS notch)\n   ===================================================== */\n\n@supports (padding: max(0px)) {\n  .mobile-header {\n    padding-left: max(16px, env(safe-area-inset-left));\n    padding-right: max(16px, env(safe-area-inset-right));\n    padding-top: max(0px, env(safe-area-inset-top));\n  }\n\n  .bottom-nav {\n    padding-left: max(8px, env(safe-area-inset-left));\n    padding-right: max(8px, env(safe-area-inset-right));\n    padding-bottom: max(0px, env(safe-area-inset-bottom));\n  }\n\n  .fab {\n    right: max(16px, env(safe-area-inset-right));\n    bottom: calc(80px + max(0px, env(safe-area-inset-bottom)));\n  }\n}\n\n/* =====================================================\n   SMOOTH SCROLLING\n   ===================================================== */\n\n@media (max-width: 767px) {\n  .email-list,\n  .email-folders-mobile,\n  .email-detail {\n    -webkit-overflow-scrolling: touch;\n    scroll-behavior: smooth;\n  }\n}\n\n/* =====================================================\n   HAPTIC FEEDBACK ANIMATION\n   ===================================================== */\n\n@media (max-width: 767px) {\n  .haptic-feedback {\n    animation: haptic-pulse 0.2s ease;\n  }\n\n  @keyframes haptic-pulse {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(0.98);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n}\n\n/* =====================================================\n   ACCESSIBILITY\n   ===================================================== */\n\n/* Focus styles for keyboard navigation */\n@media (max-width: 767px) {\n  button:focus-visible,\n  .clickable:focus-visible {\n    outline: 2px solid var(--cyan-bright);\n    outline-offset: 2px;\n  }\n}\n\n/* Reduce motion for accessibility */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
